import { ComponentType, FC } from 'react';
import styled, { css } from 'styled-components';
import { CircularProgress } from '@mui/material';

export interface IWithLoaderProps {
  loading?: boolean;
  //[key: string]: any;
}

interface ILoaderWrapperProps {
  absolute?: boolean;
  minHeight?: string;
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit';
}

const LoaderWrapper = styled.div<ILoaderWrapperProps>`
  display: flex;
  min-height: ${({ minHeight }) => minHeight || 'auto'};
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;

  ${({ absolute }) =>
    absolute &&
    css`
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    `}
`;

export const Loader = ({ minHeight = '500px', absolute, color = 'primary' }: ILoaderWrapperProps) => (
  <LoaderWrapper absolute={absolute} minHeight={minHeight}>
    <CircularProgress color={color} />
  </LoaderWrapper>
);

export const withLoader = <P extends IWithLoaderProps>(Component: ComponentType<IWithLoaderProps>): FC<P> => {
  const WithLoader = ({ loading, ...props }: IWithLoaderProps) => (loading ? <Loader /> : <Component {...props} />);

  return WithLoader;
};
